import {useEffect} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import routeMapping from '../routers/routeMapping';
import {useSelector} from 'react-redux';

// Translates every segment of a path to the route names of the given language, e.g. /studentenkorting/groningen
// becomes /student-discounts/groningen for en. Returns the path unchanged while the language is unknown.
export function translatePath(path, language) {
  const mapRoutes = routeMapping[language];
  if (!mapRoutes) return path;
  const [pathname, ...rest] = path.split(/(?=[?#])/);
  const translatedSegments = pathname.split('/').filter(Boolean).map(segment => mapRoutes[segment] || segment);
  return '/' + translatedSegments.join('/') + rest.join('');
}

const useRouteInterceptor = () => {
//  if we want to change lang based on app local

//  if we want to change lang based on .com

  const language = useSelector((state) => state.appLanguageRS);
 
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    // language is still null on a first visit until App.js has detected it; without this guard
    // a direct deep link crashes the whole app (blank page)
    if (!routeMapping[language]) return;
    const currentPath = location.pathname;

    const translatedPath = translatePath(currentPath, language);

    if (translatedPath !== currentPath) {
      history.replace(translatedPath);
    }
  }, [location, language, history]);
};

export default useRouteInterceptor;
